// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG

function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
    $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
    $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  let imgList = [[
    'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/20250923-p1_3a283436-f171-440f-ac4d-c49acaf8a84d.png?v=1758706641',
    'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/20250923-p2_e4c1c7aa-ec86-433f-88ac-964537aee049.png?v=1758706641',
    'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/20250923-p3_12201409-c97d-4fda-9a64-620177744634.png?v=1758706641',
  ],[
    "https://cdn.shopify.com/s/files/1/0703/2186/4983/files/1_3f0f81bd-5d69-45c1-aef3-f3a9c04464c2.png?v=1766559219",
    "https://cdn.shopify.com/s/files/1/0703/2186/4983/files/2_6dc2dcff-769a-45f4-a9cf-94e190a3c506.png?v=1766559219",
    'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/3_b860d781-92e2-4360-986b-180acc8d8cbf.png?v=1766559219'
  ],[
    "https://cdn.shopify.com/s/files/1/0703/2186/4983/files/4_008e6be4-ab3f-4f67-a071-7e6f6da942fc.png?v=1766559219",
    "https://cdn.shopify.com/s/files/1/0703/2186/4983/files/5_3579c7ae-c63c-4a01-86d7-07f48568efd2.png?v=1766559219",
    "https://cdn.shopify.com/s/files/1/0703/2186/4983/files/6_45980745-eb8e-4e17-83db-b4863d494bed.png?v=1766559219"
  ]]
  preloadImages(imgList)

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    new Swiper('.sp-swiper1', {
      autoplay: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.sp-pagination',
        clickable: true,
      },
    })

    $('.sp-select div').click(function () {
     const preIndex = $(this).closest(".product-box").index()
      $(this).addClass('active').siblings().removeClass('active')
      let index = $(this).index()
      $(this).closest(".product-box").find('.img-wrap1 img').attr('src', imgList[preIndex][index])
    })

    $('.sp-choose').click(function () {
      $('.sp-mask').css('display', 'flex')
      $('.sp-pop2').show()
      $('.sp-pop').show()
    })
    $('.sp-btn1').on('click', function () {
      let val1 = $(this).prev().find('.active').data('val')
      let val2 = $(this).data("val")
      console.log(val1,val2)
      let cur = window.product.find(item => item.option1 == val1 && item.option2 == val2)
      let num = 1
      window.location.href = '/cart/' + cur.id + ':' + num
    })
    $('.sp-btn-style2').click(function () {
      let id1 = $(this)
        .closest('.sp-mask')
        .find('#sp-color1')
        .find('.active')
        .data('id')
      let id2 = $(this)
        .closest('.sp-mask')
        .find('#sp-color2')
        .find('.active')
        .data('id')
      window.location.href = '/cart/' + id1 + ':' + 1 + ',' + id2 + ':' + 1
    })
    $('.sp-option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')

      let colorOptions = $('#sp-color1 .sp-option.active').index()
      let colorOptions2 = $('#sp-color2 .sp-option.active').index()
      $('#spimg1')[0].src = imgList[colorOptions]
      $('#spimg2')[0].src = imgList[colorOptions2]
    })

    $('.sp-pop2 .sp-close-btn').click(function (e) {
      $('.sp-mask').hide()
      $('.sp-pop2').hide()
    })

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            240 * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-detail')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
}

mainRender()
